// ═══════════════════════════════════════════════════════════════
// AGENCIAS · Ficha pública de agencia (agency-card.js)
// La tarjeta con la que los creadores ven una agencia en el
// Explorador: imagen de la tarjeta (o el banner recortado), nombre,
// ubicación, frase gancho (sin ella, la descripción), hitos (Titanium
// hasta 3, Gold 1) y cifras, con el color de su plan (Titanium morado,
// Gold dorado, Silver azul).
// La MISMA pieza pinta la vista previa del modal "Editar vista
// pública" de la consola, para que nunca mienta.
// Entrada: una ficha del directorio (GET /api/agency/directory, ver
// cf-worker/src/lib/agencyDirectory.js::toDirectoryEntry).
// Sus piezas (logo, cifras, ubicación, verificado, iconos de hitos) las
// reutiliza la ficha "Ver agencia" (views/explorer/agency-profile.js).
// Expone window.AgenciasAgencyCard.
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

window.AgenciasAgencyCard = (function () {
  'use strict';

  const S = () => window.AgenciasShared;
  const Geo = () => window.AgenciasRegionGeo;
  const t = (k, f) => S().t(k, f);

  const I = {
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    users: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    calendar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    verified: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="m7 12.5 3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  // Iconos de los hitos (los mismos en la tarjeta, el modal y el editor).
  const msSvg = (body, fill) => `<svg viewBox="0 0 24 24" ${fill ? 'fill="currentColor"' : 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"'}>${body}</svg>`;
  const MILESTONE_ICONS = {
    trophy: msSvg('<path d="M7 4h10v5a5 5 0 0 1-10 0z"/><path d="M7 5H4v2a3 3 0 0 0 3 3M17 5h3v2a3 3 0 0 1-3 3"/><path d="M12 14v4M8 21h8M9 18h6"/>'),
    users: msSvg('<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>'),
    star: msSvg('<path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/>', true),
    medal: msSvg('<circle cx="12" cy="15" r="6"/><path d="M8.5 10 6 2h4l2 5 2-5h4l-2.5 8"/><path d="m12 12 1 2h2l-1.5 1.3.5 2.2-2-1.2-2 1.2.5-2.2L9 14h2z"/>'),
    fire: msSvg('<path d="M12 22c4 0 7-2.7 7-7 0-3.5-2.4-6.3-4-8-.3 2.2-1.3 3.5-2.5 4C12 8 11 5 8 2c.4 3-1 5.5-2.5 7.3A8 8 0 0 0 5 15c0 4.3 3 7 7 7z"/>'),
    rocket: msSvg('<path d="M5 15c-1.5 1.3-2 5-2 5s3.7-.5 5-2c.8-.9.8-2.3-.1-3.1a2.2 2.2 0 0 0-2.9.1z"/><path d="m12 15-3-3a22 22 0 0 1 2-4A12.9 12.9 0 0 1 22 2c0 2.7-.8 7.5-6 11a22 22 0 0 1-4 2z"/><path d="M9 12H4s.6-3 2-4c1.6-1.1 5 0 5 0M12 15v5s3-.6 4-2c1.1-1.6 0-5 0-5"/>'),
  };
  const milestoneIcon = id => MILESTONE_ICONS[id] || MILESTONE_ICONS.trophy;

  // Niveles con insignia junto al nombre (imágenes en assets/agencias/tiers,
  // las pone el CSS: .agx-tier-<nivel>).
  const TIERS = ['titanium', 'gold', 'silver', 'rookie'];

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  const img = url => esc(S().safeImgUrl(url));

  function monthYear(ms) {
    if (!ms) return '—';
    // Idioma de TikControl (window.i18n.language no existe: salía el de la página).
    const lang = window.AgenciasShared?.locale?.() || window.i18n?.getCurrentLanguage?.() || 'es';
    try { return new Intl.DateTimeFormat(lang, { month: 'short', year: 'numeric' }).format(new Date(ms)); }
    catch (_) { return new Date(ms).getFullYear(); }
  }

  function logoHtml(a) {
    const inner = a.logoUrl
      ? `<img src="${img(a.logoUrl)}" alt="" loading="lazy">`
      : esc((a.name || 'A').trim().charAt(0).toUpperCase());
    return `<span class="agx-logo${a.logoUrl ? ' has-img' : ''}">${inner}</span>`;
  }

  function stat(icon, value, label) {
    return `<div class="agx-stat">${icon}<span><strong>${esc(value)}</strong><small>${esc(label)}</small></span></div>`;
  }

  // Cifras de la ficha (tarjeta y cabecera del modal "Ver agencia"); `keys`
  // elige cuáles y en qué orden (las destacadas de la guía, solo dos).
  function statsHtml(a, keys = ['creators', 'founded', 'joined']) {
    const STATS = {
      creators: () => stat(I.users, S().formatNumber(a.creators || 0), t('agencies_explorer_creators', 'Creadores')),
      founded: () => stat(I.calendar, a.foundedYear || '—', t('agencies_explorer_founded', 'Fundada')),
      joined: () => stat(I.clock, monthYear(a.joinedAt), t('agencies_explorer_joined', 'Se unió a TikControl')),
    };
    return keys.map(k => STATS[k]()).join('');
  }

  function locationHtml(a) {
    const loc = Geo().regionLabel(a.region);
    return loc ? `<span class="agx-card-loc">${I.pin}${esc(loc)}</span>` : '';
  }

  // Insignia del plan (Titanium, Gold, Silver…), detrás del nombre. La
  // tarjeta y la ficha ya van con el color del plan: solo la usan las mini
  // tarjetas de la guía de primera visita.
  function tierHtml(a) {
    if (!TIERS.includes(a.tier)) return '';
    const label = a.tier.charAt(0).toUpperCase() + a.tier.slice(1);
    return `<i class="agx-tier agx-tier-${a.tier}" title="${esc(label)}" aria-label="${esc(label)}"></i>`;
  }

  function verifiedHtml(a) {
    return a.verified ? `<i class="agx-verified" title="${esc(t('agencies_verified', 'Verificada'))}">${I.verified}</i>` : '';
  }

  // Plan con el que se pinta (color de la tarjeta y de la ficha).
  const tierOf = a => (TIERS.includes(a.tier) && a.tier !== 'rookie' ? a.tier : 'silver');

  // Imagen de la tarjeta: la suya o, si no tiene, su banner recortado; sin
  // ninguna de las dos, el logo sobre el degradado; sin logo, el nombre.
  function mediaHtml(a) {
    const src = a.cardImageUrl || a.bannerUrl;
    if (src) return `<div class="agx-card-media has-img"><img src="${img(src)}" alt="" loading="lazy"></div>`;
    if (a.logoUrl) return `<div class="agx-card-media is-logo"><img src="${img(a.logoUrl)}" alt="" loading="lazy"></div>`;
    return `<div class="agx-card-media is-empty"><span>${esc(a.name)}</span></div>`;
  }

  // Hitos de la tarjeta (el directorio ya los manda recortados según el plan
  // y sin los que son solo una imagen). Sin título, sale su detalle.
  function milestonesHtml(list) {
    const rows = (Array.isArray(list) ? list : []).filter(m => m && (m.title || m.subtitle));
    if (!rows.length) return '';
    return `<ul class="agx-card-ms">${rows.map(m => `
      <li class="is-${esc(m.icon)}"${m.title && m.subtitle ? ` title="${esc(m.subtitle)}"` : ''}>${milestoneIcon(m.icon)}<span>${esc(m.title || m.subtitle)}</span></li>`).join('')}</ul>`;
  }

  /**
   * @param {object} a     ficha del directorio
   * @param {object} [o]   { preview: true → sin data-id y con «Ver agencia» de
   *                         adorno (vista previa), index → --i para las
   *                         animaciones de entrada escalonadas }
   */
  function html(a, o = {}) {
    return `
      <article class="agx-card is-tier-${tierOf(a)}"${o.preview ? '' : ` data-agency-id="${esc(a.id)}"`}${o.index != null ? ` style="--i:${Number(o.index) || 0}"` : ''}>
        ${mediaHtml(a)}
        <div class="agx-card-body">
          <div class="agx-card-head">
            <div class="agx-card-main">
              <div class="agx-card-title"><strong>${esc(a.name)}</strong>${verifiedHtml(a)}</div>
              ${locationHtml(a)}
            </div>
            <button type="button" class="agx-card-cta"${o.preview ? ' tabindex="-1" aria-hidden="true"' : ` data-agx-open="${esc(a.id)}"`}>${t('agencies_explorer_view_agency', 'Ver agencia')}${I.arrow}</button>
          </div>
          <p class="agx-card-desc">${esc(a.tagline || a.description || t('agencies_library_public_default_desc', 'Impulsamos creadores LIVE con estrategia, formación y recursos profesionales.'))}</p>
          ${milestonesHtml(a.milestones)}
          <div class="agx-card-stats">${statsHtml(a)}</div>
        </div>
      </article>`;
  }

  return { html, logoHtml, statsHtml, locationHtml, verifiedHtml, tierHtml, tierOf, milestoneIcon, esc };
})();
